<div class="view-wrapper list-page">
	<dx-toolbar class="theme-dependent">
		<dxi-item location="before">
			<span class="toolbar-header">Munkaigény bejelentések</span>
		</dxi-item>
		<!-- <dxi-item location="before">
			<dx-tabs
				secondary="secondary"
				[width]="(ScreenService.xSmallScreenChanged | async) ? 220 : 'auto'"
				[showNavButtons]="false"
				[scrollByContent]="true"
				[selectedIndex]="0"
				[items]="taskPanelItems"
				(onItemClick)="tabValueChange($event)"
			></dx-tabs>
		</dxi-item> -->

		<dxi-item location="after" locateInMenu="auto">
			<dx-button
				icon="plus"
				text="Új munkaigény"
				type="default"
				stylingMode="contained"
				(onClick)="handleAddWorkRequest()"
			></dx-button>
		</dxi-item>

		<dxi-item
			location="after"
			locateInMenu="auto"
			widget="dxButton"
			showText="inMenu"
			[options]="{
				text: 'Refresh',
				icon: 'refresh',
				onClick: handleRefresh,
				stylingMode: 'text'
			}"
		></dxi-item>

		<dxi-item
			location="after"
			locateInMenu="auto"
			widget="dxButton"
			showText="inMenu"
			[disabled]="!displayGrid"
			[options]="{
				text: 'Column Chooser',
				icon: 'columnchooser',
				onClick: chooseColumnDataGrid,
				stylingMode: 'text'
			}"
		></dxi-item>

		<dxi-item location="after" locateInMenu="auto">
			<div class="separator"></div>
		</dxi-item>

		<dxi-item
			location="after"
			locateInMenu="auto"
			widget="dxButton"
			showText="inMenu"
			[disabled]="displayKanban"
			[options]="{
				text: 'Exportálás PDF-be',
				icon: 'exportpdf',
				onClick: exportToPdf,
				stylingMode: 'text'
			}"
		></dxi-item>

		<dxi-item
			location="after"
			locateInMenu="auto"
			widget="dxButton"
			showText="inMenu"
			[disabled]="!displayGrid"
			[options]="{
				text: 'Exportálás Excel-be',
				icon: 'exportxlsx',
				onClick: exportToXslx,
				stylingMode: 'text'
			}"
		></dxi-item>

		<dxi-item
			location="after"
			locateInMenu="auto"
			widget="dxTextBox"
			[disabled]="!displayGrid"
			[options]="{
				placeholder: 'Keresés',
				mode: 'search',
				onInput: searchDataGrid
			}"
		></dxi-item>
	</dx-toolbar>
	<ng-container *ngIf="workRequests; else loading">
		<ng-container *ngIf="workRequests" [ngSwitch]="displayTaskComponent">
			<div *ngSwitchCase="taskPanelItems[0].text" class="grid">
				<work-request-list-grid
					#planningDataGrid
					[dataSource]="workRequests"
					(tabValueChanged)="tabValueChange($event)">
				</work-request-list-grid>
			</div>
			<div *ngSwitchCase="taskPanelItems[1].text" class="kanban">
				<!-- <task-list-kanban
					#planningKanban
					[dataSource]="workRequests"
					(addTaskEvent)="addTask()">
				</task-list-kanban> -->
			</div>
		</ng-container>
	</ng-container>
	<ng-template #loading>
		<dx-load-panel
			[visible]="true"
			[showPane]="false"
			container=".content"
			message="Betöltés folyamatban..."
			[position]="{ of: '.content' }"
		>
		</dx-load-panel>
	</ng-template>
</div>
